import * as React from 'react';

function Users(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg width={16} height={19} viewBox="0 0 16 19" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M8 9.25c2.46 0 4.5-2.004 4.5-4.5 0-2.46-2.04-4.5-4.5-4.5-2.496 0-4.5 2.04-4.5 4.5 0 2.496 2.004 4.5 4.5 4.5zm1.758 1.688H6.207c-3.375 0-6.082 2.742-6.082 6.117 0 .668.527 1.195 1.195 1.195h13.325c.668 0 1.23-.527 1.23-1.195a6.122 6.122 0 00-6.117-6.117z"
        fill="#BDBDBD"
      />
    </svg>
  );
}

export default Users;
